// src/components/layout/AppLayout.js
import React from "react";
import BottomNavBar from "../../portals/fan/components/BottomNavBar";

const AppLayout = ({ children, variant = "mobile" }) => {
  if (variant === "wide") {
    return <div className="w-full min-h-screen bg-slate-100">{children}</div>;
  }

  // Mobile Layout
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-200">
      <div className="@container relative w-full max-w-[400px] h-[800px] bg-white shadow-2xl rounded-[40px] overflow-hidden border-8 border-gray-900 flex flex-col">
        {/* The page content now renders here in a scrollable container */}
        <div className="flex-grow overflow-y-auto no-scrollbar">{children}</div>

        {/* The BottomNavBar is now rendered here, and ONLY here, for the entire mobile experience */}
        <BottomNavBar />
      </div>
    </div>
  );
};

export default AppLayout;
